import { PipelineComponentType } from '@projectTypes/Pipeline';
import PipelineComponent from '../PipelineComponent';

export default class FeaturizerComponent extends PipelineComponent {
  type = PipelineComponentType.Featurizer;
  requiredComponentType = PipelineComponentType.Tokenizer;
}
